export default __webpack_public_path__ + "static/media/roogif.7c27d4ce.gif";